import { Node } from 'prosemirror-to-html-js';

export default class HeadingSimple extends Node {
  matching() {
    return this.node.type === "heading";
  }

  tag() {
    return [
      {
        tag: 'p'
      }
    ];
  }
}
